import Text from "../../../atoms/Text/Text";
import tickIcon from "../../../../assets/icons/tickIcon.svg";
import React, {useContext} from "react";
import { useCurrentRoute } from "../../../../hooks/useCurrentRoute";
import { Routes } from "../../../../routes";
import { generatePath, useHistory } from "react-router-dom";
import {ACTIONS, PopupsContext} from "../../../../contexts/PopupsContext";
import {languages} from "../../../../dummyData/dummyData";
import {goToShop} from "../../../../hooks/useCourseButtons";

const AgendaUnit = ({ courseId, unit, isActive, isCompleted }) => {
  const { callPopup } = useContext(PopupsContext);
  const history = useHistory();
  const currentRoute = useCurrentRoute(Routes.courseView);

  const getUnitNameTextProps = () => {
    let props = { s12: true, w400: true, lh14: true };

    if (unit.video_url === null) {
      props['light-5'] = true;
    } else if (isActive) {
      props['primary'] = true;
    } else {
      props['dark-4'] = true;
    }

    return props;
  }

  // TODO: use some global func?
  const timeFormat = (duration) => {
    let hrs = ~~(duration / 3600);
    let mins = ~~((duration % 3600) / 60);
    let secs = ~~duration % 60;
    let ret = "";
    if (hrs > 0) {
      ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
  };

  return (
    <div
      key={unit.block_id}
      onClick={unit.video_url !== null ?
        () => history.push(generatePath(currentRoute.base, { id: courseId, block: unit.block_id })) :
        () => callPopup({
          type: ACTIONS.INFORMATION,
          payload: {
            header: languages.EN.labels.information,
            content: (
              <>
                {languages.EN.messages.freemiumLicense}<br /><br />
                {languages.EN.messages.pleaseGoToShopFreemium}
              </>
            ),
            action: () => goToShop(courseId),
            buttonLabel: languages.EN.labels.goToShop
          },
        })
      }
      style={{ cursor: "pointer", marginBottom: "14px", }}
    >
      <Text {...getUnitNameTextProps()}>
        {unit.title + " (" + timeFormat(unit.duration) + ")"}
        {isCompleted ? (<img src={tickIcon} alt="icon" style={{ marginLeft: "5px" }} />) : ''}
      </Text>
    </div>
  );
};

export default AgendaUnit;
